<!--
  Copyright 2019 Hackware SpA <human@hackware.cl>
  This file is part of "Hackware Userland" and licensed under the terms
  of the GNU Affero General Public License version 3, or (at your option)
  a later version. You should have received a copy of this license along
  with the software. If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <div class="add-funds">
    <div class="row">
      <div class="left-column">
        <router-view />
      </div>
      <div class="right-column">
        <WalletOverview />
      </div>
    </div>
  </div>
</template>

<script>
import WalletOverview from '@/components/WalletOverview.vue';

export default {
  name: 'AddFunds',
  components: {
    WalletOverview,
  },
};
</script>

<style lang="scss">
@import "../assets/bootstrap/custom";

.left-column {
  @extend .col-sm-7;
  @extend .pt-3;
}

.right-column {
  @extend .col-sm-5;
  @extend .pt-4;
  @extend .bg-light;
  @extend .sticky-top;
  height: 100vh;
}
</style>
